<template>
  <div id="rules">
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mb-8">
        <span>{{currentPage}}/{{pageCount}}</span>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
        <vs-button 
          radius 
          color="primary" 
          type="flat"  
          icon="chevron_left"
          :disabled="currentPage === 1"
        />
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
        <vx-card>
          <pdf
            :page="currentPage"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
            :src="currentPdf"
          />
        </vx-card>
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
        <vs-button 
          radius 
          color="primary"
          type="flat"          
          icon="chevron_right"           
          :disabled="currentPage === pageCount"
        />
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-8">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">          
        </vs-col>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  name: "help-whatsapp-protocol",
  data() {
    return {
      isMounted: false,
      currentPdf: '',
      currentPage: 1,
      pageCount: 1,
      contractInfos: {}
    };
  },
  methods: {},
  created() {
    const that = this
    this.$store.dispatch("contract/contractInfos").then(() => {
      that.contractInfos = that.$store.state.contract.contract
      that.currentPdf = that.contractInfos.contract_pdf_url
    })
  },
  mounted() {
    this.isMounted = true;
  },
  components: {
    pdf
  }
};
</script>

<style lang="scss">
</style>
